import { isArray, merge, mergeWith } from "lodash";
import {
  CREATE_USER_NOTE_FAILURE,
  CREATE_USER_NOTE_REQUEST,
  CREATE_USER_NOTE_SUCCESS
} from "../types";

function customizer(objValue, srcValue) {
  if (isArray(objValue)) {
    return objValue.concat(srcValue);
  }
}

export default (state, action) => {
  switch (action.type) {
    case CREATE_USER_NOTE_REQUEST:
      return {
        ...state,
        loadingUserNotes: true
      };
    case CREATE_USER_NOTE_SUCCESS:
      return {
        ...state,
        loadingUserNotes: false,
        userNotes: mergeWith(
          merge({}, action.payload),
          state.userNotes,
          customizer
        )
      };
    case CREATE_USER_NOTE_FAILURE:
      return {
        ...state,
        loadingUserNotes: false
      };
    default:
      return state;
  }
};
